import React from "react";

const Badge = ({
  children,
  color = "bg-blue-500",
  textColor = "text-white",
}) => {
  return (
    <span
      className={`${color} ${textColor} py-1 px-3 rounded-full text-sm font-semibold`}
    >
      {children}
    </span>
  );
};

export default Badge;
